import { _useApi } from './useApiInternal'

export const useApi = (
  construct
) => {
  return (opts) => _useApi(construct, opts)
}
